import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import './CopyrightLabel.css';

export default class CopyrightLabel extends React.PureComponent {
  render() {
    const { year, company, phrase, privacyPolicyLink } = this.props;
    return (
      <div className="fc-copyright-label">
        <span role="img" aria-label="Copyright">
          &copy;
        </span>
        <span>
          {year || moment().format('YYYY')} {company} {phrase}
        </span>
        {privacyPolicyLink && (
          <>
            <br />
            <span className="privacy-policy-link">{privacyPolicyLink}</span>
          </>
        )}
      </div>
    );
  }
}

CopyrightLabel.propTypes = {
  company: PropTypes.string,
  phrase: PropTypes.string,
  year: PropTypes.number,
  privacyPolicyLink: PropTypes.element,
};

CopyrightLabel.defaultProps = {
  company: '',
  phrase: '',
  year: null,
  privacyPolicyLink: null,
};

CopyrightLabel.propOptions = {};

CopyrightLabel.dataPropsMap = {
  company: ['business', 'name'],
};
